import { Polygon } from "geojson";
import { LayerSource } from "./layersource";
import { IHistoryProject } from "../interfaces/i-history-project";
import { ICustomLegend } from "../interfaces/i-customlegend";
import { ICustomOverlayProperties } from "../interfaces/i-custom-overlay-properties";
import { ILayerConfig } from "../interfaces/i-layer-config";
import { IStyleLegendMetadata, IVectorStyle } from "../../shared/model/vector-style-definition.interface";

export class Viewerlayer {
  id: any;

  parent_id?: string;

  userId: string;

  layer?: string;

  layers?: string[];

  layersAvailable?: any[];

  layerType: string;

  order?: number;

  group_order?: number;

  name: string;

  date?: string;

  base: boolean;

  baseLayer: boolean;

  coverage?: string;

  coverageGeom?: any;

  description?: string;

  bbox?: string;

  bboxGeom?: any;

  visible: boolean;

  parent_visible?: boolean;

  opacity?: number;

  style?: string;

  styleFunction?: any;

  /** Serializable descriptor resolved to styleFunction at map-add time. Never set styleFunction directly when saving to IndexedDB. */
  styleFunctionName?: string;

  /** Serializable backend-provided style def (from geojson `.style.style`), resolved to styleFunction at map-add time. */
  styleDefinition?: IVectorStyle;

  /** AI-generated context describing styleDefinition (property_used, breakpoints, etc.) — echoed back by get_layer_geometry. */
  styleMetadata?: IStyleLegendMetadata;

  additionalStyles?: any[];

  enabled?: boolean;

  owner?: boolean;

  removable?: boolean;

  editable?: boolean;

  sharable?: boolean;

  source?: LayerSource;

  sourceName: string;

  childs?: Viewerlayer[];

  filters?: string[];

  matrixset?: string;

  matrixids?: string;

  cluster?: boolean;

  maxZoom?: number;

  minZoom?: number;

  maxResolution?: number;

  minResolution?: number;

  qaLayerId?: string;

  expandable?: boolean;

  childLayer?: boolean;

  layerGroup?: string;

  cardExpansed?: boolean;

  obliqueBufferCoverage?: number;

  bufferCoverage?: number;

  imageFormat?: string;

  tiled?: boolean;

  provider: string;

  minPixel?: number;

  maxPixel?: number;

  enableNadir?: boolean;

  enableOblique?: boolean; // enable or disable by zoom level

  enableObliqueMode?: boolean; // enable or disable by configuration

  projects?: IHistoryProject[];

  legend?: ICustomLegend;

  features?: any;

  overlayType?: string;

  customOverlayProperties?: ICustomOverlayProperties;

  enableContrast?: boolean;

  enableCropFilter?: boolean;

  config?: ILayerConfig;

  enableInfrared?: boolean;

  infraredStatus?: boolean;

  enabledMeasurements?: boolean;

  aois?: Viewerlayer[];

  enabledAois?: Viewerlayer[];

  initialData?: any;

  geometry?: Polygon;

  min_date?: string;

  max_date?: string;

  date_pretty?: string;

  min_gsd?: number;

  max_gsd?: number;

  avg_gsd?: number;

  max_zoom?: number;

  coverage_type?: string;

  aoi?: string;

  parent_aoi?: string;

  parent_group_order?: number;

  collection_id?: string;

  collection_visible?: boolean;

  collection_name?: string;

  pretty_name?: string;

  parent_pretty_name?: string;

  collectionType?: string;

  focus?: boolean;

  aoiOblique?: boolean;
}
